import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";


@Component({
  selector: 'app-gateway-svg',
  imports: [],
  templateUrl: './gateway-svg.component.html',
  styleUrl: './gateway-svg.component.css'
})
export class GatewaySvgComponent implements OnChanges {
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() online: boolean = false
  @Input() status?: string;
  @Input() backgroundColor?: string;

  ngOnChanges(changes: SimpleChanges): void {
    const currentStatus = changes['status']?.currentValue?.toUpperCase();
    if (currentStatus === "OFFLINE") {
      this.online = false
      this.backgroundColor = "#FF401F"
    } else if (currentStatus === "ONLINE") {
      this.online = true
      this.backgroundColor = "#348D1D"
    } else if (this.backgroundColor == undefined) {
      this.online = false
      this.backgroundColor = "#dfdfde"
    }
  }
}
